import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import menuReducer from './slices/menuSlice';
import orderReducer from './slices/orderSlice';
import uiReducer from './slices/uiSlice'; // Import uiReducer
import userReducer from './slices/userSlice';
import recommendedItemsReducer from './slices/recommendedItemsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    menu: menuReducer,
    order: orderReducer,
    ui: uiReducer, // Add uiReducer to the root reducer
    user: userReducer,
    recommendedItems: recommendedItemsReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {auth: AuthState, menu: MenuState, order: OrderState, ui: UIState, user: UserState, recommendedItems: RecommendedItemsState}
export type AppDispatch = typeof store.dispatch; 